import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, type ImageProperties } from 'ui/image';

type P = {
  action?: ReactNode;
  image: ImageProperties;
  meta?: ReactNode;
};

const ThumbnailImage = ({ action, image, meta }: P) => {
  const { t } = useTranslation();
  return (
    <div className="ui-thumbnail-image">
      <Image {...image} alt={image.alt ? t(image.alt) : undefined} />
      {action ? <div className="ui-thumbnail-image__action">{action}</div> : null}
      {meta ? <div className="ui-thumbnail-image__meta">{meta}</div> : null}
    </div>
  );
};

export default ThumbnailImage;
